import axios from '@/api/request';
import { BATCH_REPORT_PATH } from './constants';

/**
 * 通过 axios 批量上报埋点
 */
export async function reportEvents(events) {
  await axios.post(BATCH_REPORT_PATH, {
    events: JSON.stringify(events),
    token: sessionStorage.getItem('authorization') || '',
  });
}

/**
 * 页面卸载时通过 fetch keepalive 上报（支持 token 请求头）
 */
export function beaconReportEvents(events) {
  if (!events.length || typeof fetch !== 'function') {
    return false;
  }

  const token = sessionStorage.getItem('authorization') || '';
  const body = new URLSearchParams({
    events: JSON.stringify(events),
    token,
  }).toString();

  fetch(BATCH_REPORT_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token,
    },
    body,
    keepalive: true,
  }).catch(() => {
    // 页面卸载阶段忽略错误
  });

  return true;
}
